import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ForexGainLoss, ForexGainLossCreate, ForexGainLossFilter } from '../data/forexGainLoss';

export function createForexGainLossService(client: AxiosInstance) {
  return createCrudService<ForexGainLoss, ForexGainLossCreate, ForexGainLossFilter>(
    client,
    '/accounting/ForexGainLoss',
    'id',
  );
}

export type ForexGainLossService = CrudService<ForexGainLoss, ForexGainLossCreate, ForexGainLossFilter>;
